module.exports = __webpack_public_path__ + "media/img/pages/cv_example-b24c81a6ae87024b1d31e99358dde0b4.jpg";